import React from 'react'
import './SquareCircle.css'

const SquareCircle = () => {
  return (
    <div class="sqlcrl-loader"></div>
  )
}

export default SquareCircle